export const BS_SHORT_URL = "loop.sl";
export const BS_SHORT_URL_INVITE = BS_SHORT_URL + "/i";
export const TWITTER_URL = "https://x.com/Loopscale";
export const DISCORD_URL = "https://discord.gg/loopscale";
export const SUPPORT_URL = "https://discord.com/channels/895116209958297631/932703647236771850";
export const TERMS_URL = "https://docs.loopscale.com/resources/terms";
export const PRIVACY_URL = "https://docs.loopscale.com/resources/privacy";
export const DISCLAIMER_URL = "https://docs.loopscale.com/resources/disclaimer";
export const LOOPSCALE_MARKETING_SITE = "https://loopscale.com";
export const MERGER_ANNOUNCEMENT_URL = "https://x.com/formation_so";
export const MERGER_FAQ_URL = "https://docs.loopscale.com/resources/formation";
